import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import { CloudinaryResource, fetchImagesByTag, getThumbnailUrl, getFullSizeUrl } from '../utils/cloudinary';

const Flying: React.FC = () => {
  const [flyingImages, setFlyingImages] = useState<CloudinaryResource[]>([]);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImages, setLightboxImages] = useState<string[]>([]);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  useEffect(() => {
    fetchImagesByTag('flying', 150).then(setFlyingImages);
  }, []);

  const openLightbox = (images: string[], index: number) => {
    setLightboxImages(images);
    setLightboxIndex(index);
    setLightboxOpen(true);
  };

  return (
    <>
      <div className="text-justify">
        <br />
        <h3>Flying</h3>
        <br />
        <p>
          Flying is something that has always fascinated me: when I was growing up my Grandfather was a bush pilot in Far North Queensland, and one of my early flying memories is a flight in an old light twin with a cargo hold full of sedated crocodiles.
        </p>
        <p>
          This was wild west stuff, and it was hard for a young lad not to be struck by the sense of adventure and want to come back to aviation later in life.
        </p>
        <p>
          So, when I set out on a sabbatical break in 2018 it was only natural that I would take the chance to learn to fly myself. First in Buenos Aires in Argentina, and then much more in Southern California and <Link to="/flyinginnz">New Zealand</Link>, I took flying lessons and solo'd.
        </p>
        <p>
          I now have my private pilot's license and instrument rating and I spend most of my spare time exploring California in a Cirrus SR22.
        </p>
        <p>
          I wrote up <Link to="/flyinginnz">these notes and an itinerary</Link> for foreign pilots looking to fly a small airplane around New Zealand.
        </p>
      </div>
      <br />

      <div className="row">
        <style>{`
          div.imagetiles div.col-lg-3.col-md-3.col-sm-3.col-xs-6 {
            padding: 10px;
          }
        `}</style>

        <div className="col-md-12">
          <div className="container">
            <div className="row imagetiles">
              {flyingImages.map((image, index) => (
                <div key={image.public_id} className="col-lg-3 col-md-3 col-sm-3 col-xs-6" id="links">
                  <a
                    href={getFullSizeUrl(image.public_id)}
                    data-lightbox="gallery"
                    onClick={(e) => {
                      e.preventDefault();
                      const allImages = flyingImages.map(img => getFullSizeUrl(img.public_id));
                      openLightbox(allImages, index);
                    }}
                  >
                    <img
                      src={getThumbnailUrl(image.public_id)}
                      alt={`Flying ${index + 1}`}
                    />
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <Lightbox
        open={lightboxOpen}
        close={() => setLightboxOpen(false)}
        slides={lightboxImages.map(src => ({ src }))}
        index={lightboxIndex}
      />
    </>
  );
};

export default Flying;
